import ApiService from "@/core/services/api.service";

const BASE = "SOCIAL_CHANNEL";

export const MODULE_NAME = "SOCIAL_CHANNEL";
export const BASE_URL = "api/social/channels";

export const LOADING = `${BASE}/LOADING`;
export const ERROR = `${BASE}/ERROR`;
export const SUCCESS = `${BASE}/SUCCESS`;
export const ITEMS = `${BASE}/ITEMS`;
export const ITEM = `${BASE}/ITEM`;

export const SET_LOADING = `${BASE}/M/LOADING`;
export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SUCCESS = `${BASE}/M/SUCCESS`;
export const SET_ITEMS = `${BASE}/M/ITEMS`;
export const SET_ITEM = `${BASE}/M/ITEM`;
export const RESET_VALUES = `${BASE}/M/RESET_VALUES`;

// ACTIONS
export const GET_ITEMS = `${BASE}/GET_ITEMS`;
export const CREATE_ITEM = `${BASE}/CREATE_ITEM`;
export const UPDATE_ITEM = `${BASE}/UPDATE_ITEM`;
export const DELETE_ITEM = `${BASE}/DELETE_ITEM`;
export const ADD_MEMBERS = `${BASE}/ADD_MEMBERS`;
export const REMOVE_MEMBER = `${BASE}/REMOVE_MEMBER`;

const state = {
  items: [],
  item: null,
  loading: false,
  error: null,
  success: null,
};

const getters = {
  [LOADING]: (state) => {
    return state.loading;
  },
  [ERROR]: (state) => {
    return state.error;
  },
  [SUCCESS]: (state) => {
    return state.success;
  },
  [ITEMS]: (state) => {
    return state.items;
  },
  [ITEM]: (state) => {
    return state.item;
  },
};

const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [SET_ERROR]: (state, payload) => {
    state.error = payload;
  },
  [SET_SUCCESS]: (state, payload) => {
    state.success = payload;
  },
  [SET_ITEMS]: (state, payload) => {
    state.items = payload;
  },
  [SET_ITEM]: (state, payload) => {
    state.item = payload;
  },
  [RESET_VALUES]: (state) => {
    state.success = null;
    state.error = null;
    state.loading = false;
    state.items = [];
    state.item = null;
  },
};

const actions = {
  [GET_ITEMS]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.get(payload.url)
      .then((response) => {
        if (!payload.acceptPromise) {
          context.commit(SET_ITEMS, response.data);
        }
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return { status: false, error: error };
      });
  },

  [CREATE_ITEM]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.post(payload.url, payload.contents)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return {
          status: false,
          error: error.response?.data || error,
          code: error.response?.status || 500,
        };
      });
  },

  [UPDATE_ITEM]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.post(payload.url, payload.contents)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return {
          status: false,
          error: error.response?.data || error,
          code: error.response?.status || 500,
        };
      });
  },

  [DELETE_ITEM]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.delete(payload.url)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return {
          status: false,
          error: error.response?.data || error,
          code: error.response?.status || 500,
        };
      });
  },

  [ADD_MEMBERS]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.post(payload.url, payload.contents)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return {
          status: false,
          error: error.response?.data || error,
          code: error.response?.status || 500,
        };
      });
  },

  [REMOVE_MEMBER]: (context, payload) => {
    context.commit(SET_LOADING, true);
    return ApiService.delete(payload.url)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ERROR, null);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        return {
          status: false,
          error: error.response?.data || error,
          code: error.response?.status || 500,
        };
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
